'use client';

import * as React from 'react';
import { useUser } from 'hooks/use-user';

export interface GuestGuardProps {
  children: React.ReactNode;
  roles?: string[];
}

export function RenderForRole({ children, roles }: GuestGuardProps): React.JSX.Element | null {
  const { user, error, isLoading } = useUser();
  const [isChecking, setIsChecking] = React.useState<boolean>(true);
  const [shouldBeRendered, setShouldBeRendered] = React.useState<boolean>(false);


  const checkPermissions = async (): Promise<void> => {
    if (isLoading) {
      return;
    }

    if(!roles
      || roles.length === 0
      || user?.roles?.some(userRole => roles.some(r => r === userRole))) {
      setShouldBeRendered(true);
    }

    setIsChecking(false);
  };

  React.useEffect(() => {
    checkPermissions().catch(() => {
      // noop
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- Expected
  }, [user, error, isLoading]);

  if (isChecking || !shouldBeRendered) {
    return null;
  }

  return <React.Fragment>{children}</React.Fragment>;
}
